import IconHide from '@assets/icons/hide.svg?react';
import IconShow from '@assets/icons/show.svg?react';
import {
 Alert,
 Box,
 Button,
 IconButton,
 TextField,
 Theme,
 Typography,
} from '@mui/material';
import { useResetPasswordForm } from './useResetPasswordForm';

const ResetPasswordForm = () => {
 const {
  hasResetLinkParams,
  newPassword,
  repeatPassword,
  newPasswordVisible,
  repeatPasswordVisible,
  errorMessage,
  resetPasswordLoading,
  t,
  handleNewPasswordChange,
  handleRepeatPasswordChange,
  handleToggleNewPasswordVisibility,
  handleToggleRepeatPasswordVisibility,
  handleSubmit,
 } = useResetPasswordForm();

 return (
  <Box
   component="form"
   onSubmit={handleSubmit}
   sx={{
    width: { xs: '100%', md: '90%', lg: '80%', xl: '60%' },
    border: (theme: Theme) => `1px solid ${theme.palette.kemek.lightestGray}`,
    borderRadius: '4px',
    margin: { xs: '0 auto 16px auto', md: '0 auto' },
    p: { xs: '20px', md: 5 },
   }}
  >
   <Typography sx={{ fontSize: 18, mb: '12px' }}>
    {t('resetPassword.pageTitle')}
   </Typography>
   <Typography sx={{ fontSize: 14, mb: hasResetLinkParams ? '28px' : '12px' }}>
    {t('resetPassword.pageDescription')}
   </Typography>

   {!hasResetLinkParams && (
    <Alert severity="warning" icon={false} sx={{ mb: '28px' }}>
     {t('resetPassword.invalidResetLink')}
    </Alert>
   )}

   {errorMessage && (
    <Alert severity="error" icon={false} sx={{ mb: '28px' }}>
     {errorMessage}
    </Alert>
   )}

   <Box sx={{ position: 'relative', mb: '12px' }}>
    <TextField
     type={newPasswordVisible ? 'text' : 'password'}
     label={t('resetPassword.newPassword')}
     value={newPassword}
     onChange={handleNewPasswordChange}
     sx={{ width: '100%' }}
     slotProps={{
      inputLabel: {
       shrink: newPassword.length > 0,
      },
     }}
    />
    <IconButton
     onClick={handleToggleNewPasswordVisibility}
     aria-label={t('resetPassword.toggleNewPasswordVisibility')}
     sx={{
      position: 'absolute',
      top: '23px',
      right: '12px',
      transform: 'translateY(-50%)',
      opacity: 0.5,
      color: (theme: Theme) => theme.palette.kemek.darkGray,
     }}
    >
     {newPasswordVisible ? <IconHide /> : <IconShow />}
    </IconButton>
   </Box>

   <Box sx={{ position: 'relative', mb: { xs: 2, md: '24px' } }}>
    <TextField
     type={repeatPasswordVisible ? 'text' : 'password'}
     label={t('resetPassword.repeatNewPassword')}
     value={repeatPassword}
     onChange={handleRepeatPasswordChange}
     sx={{ width: '100%' }}
     slotProps={{
      inputLabel: {
       shrink: repeatPassword.length > 0,
      },
     }}
    />
    <IconButton
     onClick={handleToggleRepeatPasswordVisibility}
     aria-label={t('resetPassword.toggleRepeatPasswordVisibility')}
     sx={{
      position: 'absolute',
      top: '23px',
      right: '12px',
      transform: 'translateY(-50%)',
      opacity: 0.5,
      color: (theme: Theme) => theme.palette.kemek.darkGray,
     }}
    >
     {repeatPasswordVisible ? <IconHide /> : <IconShow />}
    </IconButton>
   </Box>

   <Button
    type="submit"
    variant="contained"
    size="large"
    sx={{ width: '100%' }}
    disabled={resetPasswordLoading}
   >
    {t('resetPassword.submitButton')}
   </Button>
  </Box>
 );
};

export default ResetPasswordForm;
